import { Metric } from "helpers/metrics/types";
import { useFlags } from "launchdarkly-react-client-sdk";
import { formatMessage } from "lib/globalize-util";
import { DimensionsPanelReduxState } from "reducers/dimensions-panel/dimensions-panel";
import { dimensionStateHasMetrics } from "helpers/metrics/utils";

const ROLLUP_DOOR_GROUPING_SELECTIONS_LIMIT = 2048;
const isMetricSelected = ({ showValue, showTotals, showSubtotals }: Metric) => showValue || showTotals || showSubtotals;

/**
 * custom hook that handles business rules of the errors messages
 * which DISABLES the apply button
 */
export const useErrorMessage = (
    draftState: DimensionsPanelReduxState,
    isServerRollup: boolean
): { message?: string; errorHeight?: number } => {
    const { rollupDoorGroupingSelectionsLimit } = useFlags();
    const assortmentDimensionMetrics = dimensionStateHasMetrics(draftState);
    if (!draftState.showDoors) {
        return {};
    }
    const selectedDeliveriesCount = draftState.dimensions[0].values.reduce(
        (acc, value) => (value.selected ? acc + 1 : acc),
        0
    );

    if (selectedDeliveriesCount === 0) {
        return {
            message: formatMessage("You must select at least 1 value"),
            errorHeight: 38.5,
        };
    }
    if (assortmentDimensionMetrics && isServerRollup) {
        const doorsDimension = draftState.dimensions[1];
        const isDimensionDoorSelected = doorsDimension.selected;

        const selectedDoorsCount = !isDimensionDoorSelected
            ? 0
            : doorsDimension.values.reduce((acc, value) => (value.selected ? acc + 1 : 0), 0);

        const selectedMetricsCount = draftState.metrics.values.filter(isMetricSelected)?.length || 1;

        const selectedAttributesCount =
            draftState.attributes.reduce((count, attribute) => {
                if (attribute.selected) {
                    const valuesSelected = attribute.values.filter(({ selected }) => selected).length + 1;
                    return count * valuesSelected;
                } else {
                    return count;
                }
            }, 1) || 0;

        const totalSectionSize =
            (selectedDoorsCount + 1) * (selectedDeliveriesCount + 1) * selectedAttributesCount * selectedMetricsCount;

        const isOverRollupDoorGroupingLimit =
            totalSectionSize > (rollupDoorGroupingSelectionsLimit || ROLLUP_DOOR_GROUPING_SELECTIONS_LIMIT);

        if (isOverRollupDoorGroupingLimit) {
            return {
                message: formatMessage(
                    "You have exceeded the limit of selections. Please choose fewer metrics or door groupings"
                ),
                errorHeight: 70,
            };
        }
    }
    return {};
};
